import { driveApi } from "@/api/driveApi";

/** Hands a (short-lived, anonymous) download URL to the browser's own downloader. */
function startNativeDownload(url: string): void {
    const a = document.createElement("a");
    a.href = url;
    a.rel = "noopener";
    a.style.display = "none";
    document.body.appendChild(a);
    a.click();
    a.remove();
}

/**
 * Native browser download. Mints a short-lived anonymous link
 * (POST /api/download-links) and navigates a hidden anchor to it, so the
 * browser streams the file with its own progress UI instead of us
 * buffering the whole thing into memory. One file downloads as itself;
 * a folder or several items arrive as a zip.
 */
export async function downloadItems(itemIds: string[], token: string | undefined): Promise<void> {
    if (itemIds.length === 0) return;
    const { url } = await driveApi.createDownloadLink(itemIds, token);
    startNativeDownload(url);
}

/** Native download of an older version ("Report (v3).pdf") — owner or editor. */
export async function downloadVersion(itemId: string, versionId: string, token: string | undefined): Promise<void> {
    const { url } = await driveApi.createVersionDownloadLink(itemId, versionId, token);
    startNativeDownload(url);
}
